
import store from '@/store/index';

export default {
  name: 'AssessmentLengthEstimation',

  data(): Record<string, unknown> {
    return {
      estimatedAssessmentLength: store.state.assessmentLength,
      assessmentEstimations: [
        { estimation: `1 ${this.$t('hour')}`, value: 1 },
        { estimation: `2 ${this.$t('hours')}`, value: 2 },
        { estimation: `3 ${this.$t('hours')}`, value: 3 },
        { estimation: `4 ${this.$t('hours')}`, value: 4 },
        { estimation: `5 ${this.$t('hours')}`, value: 5 },
        { estimation: `6 ${this.$t('hours')} ${this.$t('orMore')}`, value: 6 },
      ],
    };
  },

  watch: {
    estimatedAssessmentLength(): void {
      store.commit('setAssessmentLength', this.estimatedAssessmentLength);
    },
  },
};
